// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_b7772516"};